import { Check, Copy } from '@phosphor-icons/react';
import { useState } from 'react';
import type { DataAttributes } from '../types/dataAttributes';
import styles from './Form.module.css';

interface CopyFieldProps extends DataAttributes {
    label: string;
    value: string;
}

const CopyField = ({ label, value, ...dataAttributes }: CopyFieldProps) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(value);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div className={styles.credentialField}>
            <span className={styles.credentialLabel}>{label}</span>
            <div className={styles.credentialValue}>
                <code className={styles.credentialCode}>{value}</code>
                <button
                    type="button"
                    className={styles.copyButton}
                    onClick={handleCopy}
                    aria-label={`Copy ${label}`}
                    {...dataAttributes}
                >
                    {copied ? <Check size={18} weight="bold" /> : <Copy size={18} />}
                </button>
            </div>
        </div>
    );
};

export default CopyField;
